var _circle, _path, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253.476,
    cy: 256,
    r: 221.959,
    fill: "#ffd139",
    className: "colorFFD139 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#223a5e",
    d: "M253.476 409.112c-90.963 0-164.968-74.004-164.968-164.968 0-5.523 4.477-10 10-10s10 4.477 10 10c0 79.936 65.032 144.968 144.968 144.968 79.936 0 144.968-65.032 144.968-144.968 0-5.523 4.477-10 10-10s10 4.477 10 10c0 90.963-74.004 164.968-164.968 164.968z",
    className: "color223A5E svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.969,
    cy: 172.278,
    r: 37.748,
    fill: "#223a5e",
    className: "color223A5E svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.983,
    cy: 172.278,
    r: 37.748,
    fill: "#223a5e",
    className: "color223A5E svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#223a5e",
    d: "M77.49 271.065h-.078c-5.522-.042-9.965-4.553-9.923-10.076.065-8.553 4.955-24.583 22.868-30.413 17.133-5.577 32.435 3.774 38.774 10.178 3.885 3.925 3.853 10.257-.072 14.142-3.925 3.886-10.257 3.853-14.142-.072-.001 0-2.441-2.342-6.161-4.095-4.257-2.006-8.366-2.389-12.211-1.136-8.89 2.893-9.058 11.462-9.059 11.548-.04 5.497-4.509 9.924-9.996 9.924zm352.732 0h.078c5.522-.042 9.965-4.553 9.923-10.076-.065-8.553-4.955-24.583-22.868-30.413-17.133-5.577-32.435 3.774-38.774 10.178-3.885 3.925-3.853 10.257.072 14.142 3.925 3.886 10.257 3.853 14.142-.072.001 0 2.441-2.342 6.161-4.095 4.257-2.006 8.366-2.389 12.211-1.136 8.89 2.893 9.058 11.462 9.059 11.548.04 5.497 4.51 9.924 9.996 9.924z",
    className: "color223A5E svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.c45200aeb2b8c46f7cf08058bee7f465.svg";
export { ForwardRef as ReactComponent };